import React from "react";

const Services = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-16 px-6">
      <div className="max-w-6xl mx-auto text-center">
        <h1 className="text-4xl font-bold text-blue-800 mb-6">Our Services</h1>
        <p className="text-gray-700 mb-12 text-lg leading-relaxed">
          Blue Shield Labs delivers a comprehensive suite of staffing, consulting,
          and career support solutions — empowering businesses and professionals alike.
        </p>

        <div className="grid md:grid-cols-3 gap-10">
          {[
            {
              title: "Contract & Permanent Hiring",
              img: "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=900&q=80",
              desc: "Flexible recruitment models to suit every business need — from startups to enterprises.",
            },
            {
              title: "Project-Based & Retained Search",
              img: "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?auto=format&fit=crop&w=900&q=80",
              desc: "Find niche talent for complex projects through our dedicated project recruitment model.",
            },
            {
              title: "Executive Search",
              img: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=800&q=80",
              desc: "Connecting visionary leaders with organizations that drive innovation and transformation.",
            },
          ].map((s, i) => (
            <div
              key={i}
              className="bg-white shadow-md rounded-2xl hover:shadow-xl transition-all overflow-hidden"
            >
              <img src={s.img} alt={s.title} className="h-48 w-full object-cover" />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-blue-800 mb-2">{s.title}</h3>
                <p className="text-gray-600">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
